module.exports = __webpack_public_path__ + "img/dx.43464f2.svg";